import React, { useEffect, useState } from 'react'
import { NavLink, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import { isEmpty } from 'lodash';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useGetBalanceQuery, useGetInvPdfMutation, useGetInvoiceListMutation, useGetRecpPdfMutation, useGetUInvoiceListMutation, useSendRecpMutation, useUploadFileMutation } from 'config/api/waV1_user';
import getI18nStatusText from 'utils/formStatus';
import UploadButton from 'components/common/UploadButton';
import { toggleError, toggleNoti } from 'config/slice/message';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { filters } from 'config/const/global';
import { KEY_COL_LABEL_APPLIER, KEY_COL_LABEL_NAME, KEY_COL_LABEL_NAME_CN, KEY_COL_LABEL_OPERATION, KEY_COL_LABEL_PACKAGE, KEY_COL_LABEL_STATUS, KEY_COL_LABEL_UPDATEDAT, KEY_ERROR_SENT_INV_FAILED, KEY_ERROR_SENT_RECP_FAILED, KEY_LABEL_ADDED_RECORD, KEY_LABEL_CANCEL, KEY_LABEL_CONFIRM, KEY_LABEL_CURRENT_CREDIT, KEY_LABEL_DETAIL, KEY_LABEL_HELLO, KEY_LABEL_INVOICE, KEY_LABEL_RECEIPT, KEY_LABEL_RECP_ANNUAL, KEY_LABEL_RECP_ANNUAL_END, KEY_LABEL_RECP_ANNUAL_START, KEY_LABEL_SEND_RECP, KEY_LABEL_VALUE_ADDED, KEY_NOTI_SENT_RECP_SUCC, MODULE_INDIVIDUAL } from 'config/const/locale';
import SearchComponent from './search';

function createData(id, name_cn, name, applier, locale_name, update_at, status, operation, extra) {
    return { id, name_cn, name, applier, locale_name, update_at, status, operation, extra };
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'white',
    boxShadow: 24,
    p: 4,
};

export default function PAccount() {

    const { t } = useTranslation(MODULE_INDIVIDUAL)
    const [balance, setBalance] = useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [newRows, setNewRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [isAdmin, setIsAdmin] = React.useState(false);
    const [iid, setIid] = React.useState(0);
    const { user } = useSelector(state => state.global)
    const { data, isError, isSuccess } = useGetBalanceQuery()
    const dispatch = useDispatch()
    const [open, setOpen] = React.useState(false);
    const [recpVal, setRecpVal] = React.useState({
        "start_date": dayjs(format(Date.now(), 'yyyy-MM-dd')),
        "end_date": dayjs(format(Date.now(), 'yyyy-MM-dd')),
        "esar_year": dayjs(format(Date.now(), 'yyyy'))
    })

    const [getIFn] = useGetInvoiceListMutation()
    const [getUIFn] = useGetUInvoiceListMutation()
    const [uploadFileFn] = useUploadFileMutation()
    const [getInvPdfFn] = useGetInvPdfMutation()
    const [getRecpPdfFn] = useGetRecpPdfMutation()
    const [sendRecpFn] = useSendRecpMutation()

    const columns = [
        { id: 'id', label: 'id', minWidth: 20 },
        { id: 'name_cn', label: t(KEY_COL_LABEL_NAME_CN), minWidth: 100 },
        { id: 'name', label: t(KEY_COL_LABEL_NAME), minWidth: 100 },
        {
            id: 'applier',
            label: t(KEY_COL_LABEL_APPLIER),
            minWidth: 100,
            align: 'right',
        },
        {
            id: 'locale_name',
            label: t(KEY_COL_LABEL_PACKAGE),
            minWidth: 100,
            align: 'right',
        },
        {
            id: 'update_at',
            label: t(KEY_COL_LABEL_UPDATEDAT),
            minWidth: 100,
            align: 'right',
        },
        {
            id: 'status',
            label: t(KEY_COL_LABEL_STATUS),
            minWidth: 100,
            align: 'right',
        },
        {
            id: 'operation',
            label: t(KEY_COL_LABEL_OPERATION),
            minWidth: 100,
            align: 'right',
        }
    ];


    const [filterText, setFilterText] = useState(''); // keyword to search
    const [filterType, setFilterType] = useState(columns[0]?.id) // type to search with keyword
    // const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    // filter results when conditions meet
    let filteredItems = newRows.filter(
        item => item[filterType] && String(item[filterType]).toLowerCase().includes(filterText.toLowerCase())
    );


    const handleOpen = (invId) => () => {
        setOpen(true)
        setIid(invId)
    };
    const handleClose = () => setOpen(false);

    const handleSendRecp = () => {

        sendRecpFn({
            invoice_id: iid,
            service_payload: {
                "start_date": format(recpVal.start_date.toISOString(), 'yyyy-MM-dd'),
                "end_date": format(recpVal.end_date.toISOString(), 'yyyy-MM-dd'),
                "esar_year": format(recpVal.esar_year.toISOString(), 'yyyy')
            }
        })
            .then(res => {
                if (res.data?.data) {
                    dispatch(toggleNoti({
                        indicator: true,
                        msg: t(KEY_NOTI_SENT_RECP_SUCC)
                    }))
                    window.open(res.data?.data?.receipt?.pdf)
                    handleClose()
                    window.location.reload()
                } else {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_SENT_RECP_FAILED)
                    }))
                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_SENT_RECP_FAILED)
                }))
            })
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleInvoice = (iid) => () => {
        getInvPdfFn(iid)
            .then(res => {
                if (res.data?.data) {
                    window.open(res.data?.data)
                } else {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_SENT_INV_FAILED)
                    }))
                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_SENT_INV_FAILED)
                }))
            })
    }

    const handleReceipt = (iid) => () => {
        getRecpPdfFn(iid)
            .then(res => {
                if (res.data?.data) {
                    window.open(res.data?.data)
                } else {

                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_SENT_INV_FAILED)
                }))
            })
    }

    const openRecp = (url) => () => {
        window.open(url)
    }

    useEffect(() => {
        if (isSuccess) setBalance(data?.data?.balance)
    }, [isSuccess])

    useEffect(() => {
        if (user?.user_roles?.includes("admin")) setIsAdmin(true)
        else setIsAdmin(false)
    }, [user])

    useEffect(() => {
        if (isAdmin) {
            getIFn(filters.except_recharge)
                .then(
                    res => {
                        if (res.data?.data)
                            setNewRows(new Array(...res.data?.data?.invoices?.data).map(
                                i => createData(i.user_service?.id, i.user_service?.company_name_zh, i.user_service?.company_name_en, i.user_service?.user?.name, i.user_service?.service?.locale_name, i.user_service?.updated_at, i.user_service?.status,
                                    <>
                                        <Button><Link to={'/detailed'} state={{ ...i, name: i?.user?.name }}>{t(KEY_LABEL_DETAIL)}</Link></Button>
                                        <UploadButton uid={i?.user_id} sid={i?.user_service?.service_id} usid={i?.user_service?.id} />
                                        <Button onClick={handleInvoice(i.id)} >{t(KEY_LABEL_INVOICE)}</Button>
                                        {
                                            isEmpty(i.receipts)
                                                ? false
                                                // : <Button onClick={handleReceipt(i.receipts[0]?.id)} >收據</Button>
                                                : (
                                                    <Select
                                                        value={0}
                                                        className='wa-no-border-all'
                                                        sx={{
                                                            '& *': { borderWidth: 0 }
                                                        }}
                                                    >
                                                        <MenuItem value={0} hidden>{t(KEY_LABEL_RECEIPT)}</MenuItem>
                                                        {
                                                            i.receipts.map(
                                                                item => <MenuItem onClick={openRecp(item?.pdf)}>{item?.receipt_no}</MenuItem>
                                                            )
                                                        }
                                                    </Select>
                                                )
                                        }
                                    </>,
                                    i
                                )
                            ))
                    }
                )
        }
        else {
            getUIFn(filters.except_recharge)
                .then(
                    res => {
                        if (res.data?.data)
                            setNewRows(new Array(...res.data?.data?.invoices?.data).map(
                                i => createData(i.user_service?.id, i.user_service?.company_name_zh, i.user_service?.company_name_en, i.user_service?.user?.name, i.user_service?.service?.locale_name, i.user_service?.updated_at, i.user_service?.status,
                                    <>
                                        <Button><Link to={'/detailed'} state={{ ...i, name: i?.user?.name }}>{t(KEY_LABEL_DETAIL)}</Link></Button>
                                        <UploadButton uid={i?.user_id} sid={i?.user_service?.service_id} usid={i?.user_service?.id} />
                                        <Button onClick={handleInvoice(i.id)} >{t(KEY_LABEL_INVOICE)}</Button>
                                        {/* {
                                            isEmpty(i.receipts) ? false : <Button onClick={handleReceipt(i.receipts[0]?.id)} >收據</Button>
                                        } */}
                                        {
                                            isEmpty(i.receipts)
                                                ? false
                                                // : <Button onClick={handleReceipt(i.receipts[0]?.id)} >收據</Button>
                                                : (
                                                    <Select
                                                        value={0}
                                                        className='wa-no-border-all'
                                                        sx={{
                                                            '& *': { borderWidth: 0 }
                                                        }}
                                                    >
                                                        <MenuItem value={0} hidden>{t(KEY_LABEL_RECEIPT)}</MenuItem>
                                                        {
                                                            i.receipts.map(
                                                                item => <MenuItem onClick={openRecp(item?.pdf)}>{item?.receipt_no}</MenuItem>
                                                            )
                                                        }
                                                    </Select>
                                                )
                                        }
                                    </>,
                                    i
                                )
                            ))
                    }
                )
        }

    }, [isAdmin])

    return (
        <Box sx={{ width: '100%', m: '0 auto', backgroundColor: 'white', borderRadius: 5, p: 2 }}>
            <Grid container spacing={2}>
                <Grid item lg={3}>
                    <Stack direction='column' alignItems='center' >
                        {/* <Avatar sx={{ width: 81, height: 81, mb: 1 }}>H</Avatar> */}
                        <Typography variant='h4' >{t(KEY_LABEL_HELLO)}</Typography>
                        <Typography variant='h4' >{user.name}</Typography>
                    </Stack>
                </Grid>
                <Grid item lg={3} >
                    <Stack direction='column' alignItems='center' justifyContent='center' sx={{ height: '100%' }} >
                        <Typography variant='h4' >{t(KEY_LABEL_CURRENT_CREDIT)} {balance}</Typography>
                    </Stack>
                </Grid>
                <Grid item lg={2}>
                    <Stack direction='column' alignItems='center' justifyContent='center' sx={{ height: '100%' }} >
                        <Button variant="outlined" size='large'><NavLink to={'/wallet'}><Typography variant='h6' >{t(KEY_LABEL_VALUE_ADDED)}</Typography></NavLink></Button>
                    </Stack>
                </Grid>
            </Grid>

            <hr />
            <SearchComponent columns={columns} Kword={filterText} saveKeyword={setFilterText} KType={filterType} ChangeKType={setFilterType} />
            <hr />
            <Typography variant='h5'>{t(KEY_LABEL_ADDED_RECORD)}</Typography>
            <Paper sx={{ width: '100%' }}>
                <TableContainer sx={{ maxHeight: 1080 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ top: 0, minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredItems
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => {
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                            {columns.map((column) => {
                                                const value = row[column.id];
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {
                                                            column.format && typeof value === 'number'
                                                                ? column.format(value)
                                                                : column.id == 'status'
                                                                    ? getI18nStatusText(value)
                                                                    : column.id == 'operation'
                                                                        ? isAdmin
                                                                            ? (
                                                                                <div>
                                                                                    {
                                                                                        value
                                                                                    }
                                                                                    <Button onClick={handleOpen(row?.extra?.id)}>{t(KEY_LABEL_SEND_RECP)}</Button>

                                                                                </div>
                                                                            ) : value
                                                                        : value
                                                        }
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>

                        <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            className='wa-white-50'
                        >
                            <Box sx={style}>
                                <Grid container spacing={2} >
                                    <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Typography variant='h5'>
                                            {t(KEY_LABEL_RECP_ANNUAL)}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                views={['year']}
                                                value={recpVal.esar_year}
                                                onChange={(newValue) => setRecpVal(p => ({ ...p, esar_year: newValue }))}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Typography variant='h5'>
                                            {t(KEY_LABEL_RECP_ANNUAL_START)}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={recpVal.start_date}
                                                onChange={(newValue) => setRecpVal(p => ({ ...p, start_date: newValue }))}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Typography variant='h5'>
                                            {t(KEY_LABEL_RECP_ANNUAL_END)}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={recpVal.end_date}
                                                onChange={(newValue) => setRecpVal(p => ({ ...p, end_date: newValue }))}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                        <Button onClick={handleSendRecp}>{t(KEY_LABEL_CONFIRM)}</Button>
                                    </Grid>
                                    <Grid item sm={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                        <Button onClick={handleClose}>{t(KEY_LABEL_CANCEL)}</Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Modal>

                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={filteredItems.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    )
}
